<template>
  <div class="container">
     <content-title :nav="nav"></content-title>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      
    </auto-table>

  </div>
</template>

<script>


export default {
 
  data() {
    return {
         nav: { firstNav: "官网申请", secondNav: "申请列表" },
      DataList: [],
      query: {
        
      },
      Option: [
        { name: "姓名", value: "principal_name" },
        { name: "电话", value: "principal_mobile" },
        { name: "申请来源", value: "else_img" },
        { name: "内容", value: "mechanism_name" },
      ],
      Total: 0
    };
  },
 
  mounted() {
    this.getList(1);
  },

  methods: {
    openAdd(){
        this.$refs.edit.open()
    },
    openUpdate(row){
        this.$refs.edit.open(row)
    },
    //列表
    getList(v) {
      let page = v || 1;
      let params = {
        currentPage: page,
        pageSize: 10,
        ...this.query
      };
      this.$axios({
        url: "/user/mechanismIntention/queryManagerListPage",
        params,
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>